import React, {useEffect, useState} from "react"
import {saveTemplate} from "../../../../../../stateManager/store/table/actions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../../../../../stateManager/store";
import {updateElement} from "../../../../../../stateManager/store/formCreation_v2/actions";
import {templateSvgs} from "./templateSvgs";

export const TemplateImgs = () => {

  const [ selectedTemplate, setSelectedTemplate ] = useState<any>({
    "_id": "template1",
    "icon": "/static/media/template1.fa337289.svg",
    "label": "Template 1",
    "style": {
      "header": {
        "border": "none",
        "background": "white",
        "color": "#121212"
      },
      "body": {
        "border": "none",
        "color": "#121212"
      },
      "bodyBackground": {
        "background": "white"
      }
    }
  })
  const {selectedElementId, components} = useSelector((state: AppState) => state.formJson);
  const selectedTemplateIcon = components[selectedElementId]?.properties?.config?.template?.icon
  const {config} = components && selectedElementId && components[selectedElementId] && components[selectedElementId]?.properties
  const [ tableDefaults, setTableDefaults ] = useState<any>(null)
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTemplate) {
      dispatch(saveTemplate(selectedTemplate))
    }
  }, [ selectedTemplate ])

  const handleChange = (path: any, value: any) => {
    dispatch(
      updateElement({
        id: selectedElementId,
        path,
        value,
      })
    );
  }
  useEffect(() => {
    if (config) {
      setTableDefaults(config)
    }
  }, [config])

  useEffect(() => {
    if (tableDefaults) {
      handleChange("properties.config", tableDefaults);
    }
  }, [ tableDefaults ])

  const handleSelectedTemplate = (item: any) => {
    setTableDefaults((prev:any) =>  ({...prev, 
      "template": item,
      "headerColor": item?.style?.header?.background || "",
      "headerTextColor": item?.style?.header?.color || "",
      "cellTextColor": item?.style?.body?.color || "",
      "selectionColor": "",
      "hoverColor": "",
      "rowEvenColor": item?.style?.bodyBackground?.even?.background || "",
      "rowOddColor": item?.style?.bodyBackground?.odd?.background || "",
    }))
    setSelectedTemplate(item)
  }

  return (
    <div style={{width: "100%", justifyContent: "space-between", display: "flex", overflow: "auto", flexWrap: "wrap"}}>
      {
        templateSvgs.map((item: any, i) => {
          return <div onClick={() => {handleSelectedTemplate(item)}}
            style={{
              cursor: "pointer", margin: "5px",
              border: ((item && item?.icon) === (selectedTemplateIcon)) ? "1px solid #0466C8" : "1px solid #D9D9D9",
              borderRadius: "3px"
            }}>
            <img src={item.icon} style={{margin: "5px"}} height="30px" width="60px" alt="templates" />
          </div>
        })
      }
    </div>
  )
};
